module.exports = __webpack_public_path__ + "img/2-1.3be62410.png";